export default __webpack_public_path__ + "static/media/ic_aave_40.abd927d8.svg";